<template>
  <VCard
      color="transparent"
      class="shadow-none"
  >
    <VCardTitle class="pb-4">
      <VContainer
          fluid
          class="py-0"
      >
        <VRow>
          <VCol
              cols="12"
              class="pb-0"
          >
            <ContactUsHeader
                :title="title"
                :subtitle="subtitle"
            />
          </VCol>
        </VRow>
      </VContainer>
    </VCardTitle>
    <VCardText class="pt-4">
      <VContainer
          fluid
          class="py-0"
      >
        <VRow>
          <VCol
              cols="12"
              lg="7"
              md="7"
              sm="12"
              xs="12"
          >
            <ContactUsForm
                :validationErrors="validationErrors"
                :contactForm="contactForm"
                :successModal="successModal"
                @setGlobalLoading="state => $emit('setGlobalLoading', state)"
            />
          </VCol>
          <VCol
              cols="12"
              lg="5"
              md="5"
              sm="12"
              xs="12"
          >
            <ContactUsContactInfo
                :companyName="contactInfo.companyName"
                :phoneNumber="contactInfo.phoneNumber"
                :email="contactInfo.email"
                :address="contactInfo.address"
            />
          </VCol>
        </VRow>
      </VContainer>
    </VCardText>
  </VCard>
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'ContactUsPage',
  metaInfo() {
    return getMetaInfo((this as { seo?: unknown }).seo);
  },
};
</script>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import StrapiService from '@slg/web-customer-shared/src/services/StrapiService';
import ContactUsHeader from './ContactUsHeader.vue';
import ContactUsContactInfo from './ContactUsContactInfo.vue';
import ContactUsForm from './ContactUsForm.vue';
import { useCmsLocaleReload } from '../../composables';

const subtitle = ref('');
const title = ref('');
const seo = ref('');
const successModal = reactive({
  sendAnotherMessageBtnText: '',
  successMessage: '',
});
const contactForm = reactive({
  fullName: '',
  phone: '',
  email: '',
  message: '',
  send: '',
});
const contactInfo = reactive({
  companyName: '',
  phoneNumber: '',
  email: '',
  address: '',
});
const validationErrors = reactive({
  emailMax255: '',
  emailRegex: '',
  fullNameMax255: '',
  messageMax500: '',
  numbersAndSymbols: '',
  phoneRegex: '',
});

function loadContactInfo() {
  return StrapiService.getContactUs();
}

async function loadCmsData() {
  try {
    const data = await loadContactInfo();
    seo.value = data.Seo;

    title.value = data.Title;
    subtitle.value = data.Subtitle;

    successModal.successMessage = data.SuccessModal.SuccessMessage;
    successModal.sendAnotherMessageBtnText = data.SuccessModal.sendAnotherMessageButtonText;

    contactInfo.companyName = data.ContactInformation?.CompanyName;
    contactInfo.phoneNumber = data.ContactInformation?.PhoneNumber;
    contactInfo.email = data.ContactInformation?.ContactEmail;
    contactInfo.address = data.ContactInformation?.Address;

    contactForm.fullName = data.ContactForm?.FullName;
    contactForm.phone = data.ContactForm?.Phone;
    contactForm.email = data.ContactForm?.Email;
    contactForm.message = data.ContactForm?.Message;
    contactForm.send = data.ContactForm?.Send;

    validationErrors.emailMax255 = data.ValidationErrors?.EmailMax255;
    validationErrors.emailRegex = data.ValidationErrors?.EmailRegex;
    validationErrors.fullNameMax255 = data.ValidationErrors?.FullNameMax255;
    validationErrors.messageMax500 = data.ValidationErrors?.MessageMax500;
    validationErrors.numbersAndSymbols = data.ValidationErrors?.NumbersAndSymbols;
    validationErrors.phoneRegex = data.ValidationErrors?.PhoneRegex;
  } catch (e) {
    // to-do rethink about catch
  }
}

useCmsLocaleReload(loadCmsData);
</script>

<style scoped>

</style>
